<template>
  <el-dropdown style="padding:0px" @command="handleCommand">
    <span class="el-dropdown-link">
      <!-- 下拉菜单 -->
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="">全部</el-dropdown-item>
      <el-dropdown-item command="平时白班">平时白班</el-dropdown-item>
      <el-dropdown-item command="平时晚班">平时晚班</el-dropdown-item>
      <el-dropdown-item command="周末白班">周末白班</el-dropdown-item>
      <el-dropdown-item command="周末晚班">周末晚班</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
 
<script>
export default {
  data() { 
    return {
      value: ""
    };
  },
  props: {
    options: {
      type: Array,
      default: function() {
        return [
        ];
      }
    }
  },
  watch: {
    defaultValue(newVal, oldVal) {
      let self = this;
      self.value = newVal;
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit("selectChange", command);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/classManage/SelectHeader.vue